import './assets/styles/index.scss';

import { FC, useEffect } from 'react';

import Layout from 'components/layout/Layout/Layout';
import ThemeProvider from '@trackman/web-shared-components/styles/Theme';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';
import { useSasTokenPreloader } from 'hooks/useSasTokenPreloader';

type Props = {
  children?: React.ReactNode;
};

export const App: FC<Props> = observer((props) => {
  const ss = useStores().startupStore;
  const apiServiceAxiosInstance = useStores().apiServiceAxiosInstance;
  const organizationId = useStores().profileStore?.organizationId;

  useEffect(() => {
    ss.initialize(apiServiceAxiosInstance);
  }, [ss, apiServiceAxiosInstance]);

  // Preload and cache SAS token for video access
  useSasTokenPreloader(organizationId);

  return (
    <ThemeProvider>
      <Layout>{props.children}</Layout>
    </ThemeProvider>
  );
});

export default App;
